<template>
	<div class="header-wrapper">
		<header class="page-header text-md-center">
			<div class="container">
				<!-- Branding -->
				<img src="./../assets/logo.svg" alt="Reiturn by Birgo" class="logo">

				<!-- Investor Support -->
				<a href="tel:14125220799" class="investor-support d-none">
					<img src="./../assets/deanna-lujan.jpg" class="avatar" alt="Deanna Lujan">
					<i>Any Questions for Investor Relations?</i>
					<h3>Deanna Lujan</h3>
					<span class="phone-item">
						<img src="./../assets/icons/phone.svg" alt="Phone">
						<strong>(412) 522-0799</strong>
					</span>
				</a>
			</div>
		</header>
		<div class="pre-authenticated-header" v-if="isPreAuthenticated">
			<div class="container">
				<div class="person-details">
					<span>Signed in as:</span>
					<strong>{{ emailAddress }}</strong>
				</div>
				<router-link to="/sign-out">Sign Out</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "Header",
    computed: {
        isPreAuthenticated() {
            return this.$store.getters.auth.preAuthenticated;
		},
        emailAddress() {
            return this.$store.getters.auth.email;
		},
		currentRoute() {
            return this.$route.path;
		},
    },
}
</script>

<style lang="scss">
.page-header {
	background: #fff;
	border-bottom: 1px solid #ddd;
	padding: 1.5rem 0;

	@media (max-width: 767.99px) {
		border-bottom: none;
	}

	.logo {
		height: 2.5rem;
	}

	.investor-support {
		position: absolute;
		top: 0.15rem;
		right: 0.25rem;
		text-decoration: none;
		color: inherit;
		display: block;
		padding: 0.75rem 0.75rem 0.75rem 5rem;
		text-align: left;
		background: #fff;
		//box-shadow: rgba(#16193A, 0.1) 0 0.1rem 0.2rem;
		border-radius: 0.5rem;
		transition: 0.15s ease all;

		@media (max-width: 767px) {
			//right: 0;
			//top: 0;
			//padding: 0.5rem 0.75rem 0.75rem 4.5rem;
			//max-width: calc(100% + 1.5rem);
			//margin: 1rem -0.75rem 0 -0.75rem;
			//border-radius: 0;
			//position: relative;
			//box-shadow: none;
			top: 0.5rem;
			right: 0.25rem;
			padding: 0 0 0 3rem;
			box-shadow: none;
			border-radius: 0;
			max-width: 50%;
			position: absolute;
		}

		&:hover {
			background: #f2f3f4;

			@media (max-width: 767px) {
				background: none;
			}
		}

		&:active {
			transform-origin: center;
			transform: scale(0.975);
			background: #f2f3f4;

			@media (max-width: 767px) {
				box-shadow: none;
				background: none;
			}
		}

		img.avatar {
			position: absolute;
			width: 3.5rem;
			height: 3.5rem;
			left: 0.75rem;
			top: 0;
			bottom: 0;
			margin: auto;
			border-radius: 50%;
			object-fit: cover;

			@media(max-width: 767px) {
				//width: 3rem;
				//height: 3rem;
				//left: 0.75rem;
				width: 2rem;
				height: 2rem;
				left: 0;
			}
		}

		i {
			font-style: normal;
			font-size: 0.8rem;
			color: rgba(#16193A, 0.75);
			font-weight: 600;
			line-height: 1.2;
			display: block;

			@media (max-width: 767px) {
				font-weight: 400;
			}
		}

		h3 {
			display: block;
			font-weight: bold;
			color: #16193A;
			font-size: 1.25rem;
			margin: 0;
			line-height: 1.2;

			@media (max-width: 767px) {
				font-size: 1rem;
			}
		}

		strong {
			display: block;
			font-weight: bold;
			color: #F37021;
			line-height: 1.2;

			@media (max-width: 767px) {
				font-size: 0.8rem;
			}
		}

		.phone-item {
			display: flex;
			align-items: center;

			img {
				width: 1rem;
				height: 1rem;
				margin-right: 0.25rem;

				@media (max-width: 767px) {
					width: 0.75rem;
					height: 0.75rem;
				}
			}
		}
	}
}

.pre-authenticated-header {
	border-bottom: 1px solid #ddd;

	.container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.75rem 0;

		@media (max-width: 767px) {
			padding: 0.75rem 0.75rem;
		}

		.person-details {
			color: #16193A;
			font-size: 0.8rem;
			display: flex;
			align-items: center;

			@media (max-width: 767px) {
				flex-direction: column;
				align-items: flex-start;
			}

			strong {
				margin-left: 0.25rem;
				color: #F37021;

				@media (max-width: 767px) {
					margin-left: 0;
					margin-top: -0.15rem;
				}
			}
		}

		a {
			color: #16193A;
			font-weight: bold;
			font-size: 0.8rem;
		}
	}
}
</style>